import { render, staticRenderFns } from "./accountMenu.vue?vue&type=template&id=70895bae"
import script from "./accountMenu.vue?vue&type=script&lang=js"
export * from "./accountMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports